// export const acceptedTypesString: string = 'image/png, image/jpeg, image/webp, image/gif';

export const acceptedTypesString: string = 'image/png, image/jpeg, image/webp';

export const acceptedTypesArray: string[] = [
    'image/png',
    'image/jpeg',
    'image/webp',
   // 'image/gif',
];
